$below-small: "max-width: 480px";

.card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.number {
    composes: fontHB120 from "../../../styles/typography.module.scss";
    text-align: center;
}

.media {
    max-width: 100%;
    flex-shrink: 0;

    // For inline SVGs
    :global(.imageDataWrapper) {
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: 80px;
            color: var(--color-contrast);

            @media ($below-small) {
                height: 48px;
            }
        }
    }

    picture,
    img,
    video {
        max-width: 100%;
        height: auto;
    }

    img,
    video {
        object-fit: contain;
    }
}

.mediaElement {
    width: 100%;
    height: 100%;
}

.headline {
    composes: fontHB40 from "../../../styles/typography.module.scss";
    text-align: center;
    margin-top: var(--spacer-24);
}

.body {
    composes: fontP20 from "../../../styles/typography.module.scss";
    text-align: center;
    margin-top: var(--spacer-12);
    flex-grow: 1;

    @media ($below-small) {
        font-size: 16px;
    }
}

.link {
    margin-top: auto;
    padding-top: var(--spacer-16);

    @media ($below-small) {
        font-size: 16px;
    }
}
